import { IsCoach, IsPageAccessible } from "../config/Roles";
import { apiRequest } from "../utils/api";

const GetSessionData = async id => {
  const response = await apiRequest.get(
    `/api/getSessionDetails?session_id=${id}`
  );
  if (response.status === 200) {
    const data = response.data.data;
    if (!IsPageAccessible(data.session?.coach_id, data.session?.coachee_id)) {
      const url = IsCoach() ? "/sessions/teams" : "/sessions/personal";

      window.location = url;
    }
    // AI Coaching pilot region gate: computed backend-side from this
    // session's own campaign -> region (authoritative, same chain the
    // controller enforces on), so callers can set CampaignContext's
    // isAiCoachingEnabled without a separate campaign-list round trip. See
    // alt-ai-coaching-pilot.md.
    return { ...data, ai_coaching_enabled: response.data.ai_coaching_enabled };
  } else {
    return false;
  }
};
export default GetSessionData;
